import React from 'react'
import { getSectorLabel, SectorModel } from '../domain/sector.model'

export interface SectorContextI {
  sectors: SectorModel[]
  supportedLocales: string[]
  getSectorLabelById: (id: string, lang: string) => string
  refreshSectors: () => void
}

const SectorContext = React.createContext<SectorContextI>({
  sectors: [],
  supportedLocales: ['en', 'fr'],
  getSectorLabelById: (id: string) => id,
  refreshSectors: () => {},
})

export { getSectorLabel }
export default SectorContext
